








































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';
import MyForm from '@/mixins/form';
import Rules from './rules.vue';

@Component({
  components: {
    Rules,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() applist!: any;

  @Prop() stadiumIds!: any[];

  @Prop() multiParamsSetting!: any[];

  @Prop() reloadData!: Function;

  rules: any[] = [];

  mounted() {
    console.log('multiParamsSetting', this.multiParamsSetting);
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldsValue) {
              if (_.get(fieldsValue, [key])) {
                const fieldValue = _.get(fieldsValue, [key]);

                if (fieldValue) {
                  if (key === 'rules') {
                    console.log('properties', fieldValue);
                    const props: any[] = [];
                    fieldValue.forEach((el: any) => {
                      if (el.group == el.name) {
                        Object.keys(el.valueMap).forEach((key: string) => {
                          props.push({
                            name: key,
                            value: el.valueMap[key],
                          });
                        });
                      } else {
                        props.push(el);
                      }
                    });

                    _.set(values, ['properties'], JSON.stringify(props));
                  } else if (moment.isMoment(fieldValue)) {
                    _.set(
                      values,
                      [key],
                      moment(fieldValue).format('YYYY-MM-DD HH:mm:ss'),
                    );
                  } else if (_.isArray(fieldValue)) {
                    _.set(values, [key], JSON.stringify(fieldValue));
                  } else {
                    _.set(values, [key], fieldValue);
                  }
                }
              }
            }

            _.set(values, ['stadium_ids'], this.stadiumIds.join(','));

            const res = await this.$store.dispatch(
              'stadium/postParamsSetting',
              {
                ...values,
              },
            );

            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.reloadData();
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
